import type { MergeBrandsRequest, MergeBrandsResponse } from '@rock/types';
import { MergeBrandsResponseSchema } from '@rock/types';
import { getFunctions, httpsCallable } from 'firebase/functions';

/**
 * Merge one brand into another, server-side (`mergeBrands`). `dryRun: true` returns the preview counts
 * the confirm step shows; the real run returns the ledger id. A refusal (self-merge, into a junk or
 * merged brand, a shared nameplate) comes back as a status, not an error.
 */
export async function mergeBrands(request: MergeBrandsRequest): Promise<MergeBrandsResponse> {
    // The server runs every stage in one call (up to 540 s); the client default of 70 s would give up first.
    const fn = httpsCallable<MergeBrandsRequest, MergeBrandsResponse>(getFunctions(), 'mergeBrands', {
        timeout: 540_000,
    });
    const result = await fn(request);
    return MergeBrandsResponseSchema.parse(result.data);
}
